import { useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import axios from 'axios';
import { toast } from 'sonner';
import { Building2, Send } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const BulkInquiry = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/bulk-requests`, formData);
      toast.success('Your bulk inquiry has been submitted! We will contact you soon.');
      setFormData({ name: '', email: '', phone: '', company: '', message: '' });
    } catch (error) {
      console.error('Error submitting bulk inquiry:', error);
      toast.error('Failed to submit inquiry. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-[1000px] mx-auto px-6 md:px-12 py-12">
      <div className="text-center mb-12">
        <Building2 size={48} className="mx-auto text-[#D4AF37] mb-4" />
        <h1 className="text-3xl md:text-4xl font-bold mb-4" style={{fontFamily: 'Playfair Display, serif'}} data-testid="bulk-inquiry-title">
          Bulk Order Inquiry
        </h1>
        <p className="text-gray-600 max-w-2xl mx-auto">
          Looking to purchase in bulk? Fill out the form below and our team will get back to you with special pricing and offers.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="card p-8">
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <Label htmlFor="name">Full Name *</Label>
              <Input
                id="name"
                name="name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                required
                className="mt-2"
                data-testid="bulk-name-input"
              />
            </div>

            <div>
              <Label htmlFor="phone">Phone Number *</Label>
              <Input
                id="phone"
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                required
                className="mt-2"
                data-testid="bulk-phone-input"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <Label htmlFor="email">Email Address *</Label>
              <Input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="mt-2"
                data-testid="bulk-email-input"
              />
            </div>

            <div>
              <Label htmlFor="company">Company Name (Optional)</Label>
              <Input
                id="company"
                name="company"
                type="text"
                value={formData.company}
                onChange={handleChange}
                className="mt-2"
                data-testid="bulk-company-input"
              />
            </div>
          </div>

          <div>
            <Label htmlFor="message">Message / Requirements *</Label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows={6}
              className="w-full mt-2 px-3 py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
              placeholder="Tell us about your requirements, quantity needed, delivery location, etc."
              data-testid="bulk-message-input"
            />
          </div>

          <Button type="submit" className="w-full bg-[#D4AF37] text-white hover:bg-[#c9a22e]" disabled={loading} data-testid="bulk-submit-btn">
            <Send className="mr-2" size={20} />
            {loading ? 'Submitting...' : 'Submit Inquiry'}
          </Button>
        </div>
      </form>
    </div>
  );
};
